import { render, staticRenderFns } from "./take-photo.vue?vue&type=template&id=fb631d14&scoped=true&lang=pug&"
import script from "./take-photo.vue?vue&type=script&lang=js&"
export * from "./take-photo.vue?vue&type=script&lang=js&"
import style0 from "./take-photo.vue?vue&type=style&index=0&id=fb631d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb631d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb631d14')) {
      api.createRecord('fb631d14', component.options)
    } else {
      api.reload('fb631d14', component.options)
    }
    module.hot.accept("./take-photo.vue?vue&type=template&id=fb631d14&scoped=true&lang=pug&", function () {
      api.rerender('fb631d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photos/take/take-photo.vue"
export default component.exports